// Claves de localStorage del chat de María. En archivo aparte (no en Maria.jsx)
// para que AuthContext.jsx pueda limpiarlas en el logout sin crear un import circular.
export const KEY_DIA = "maria_saludo_dia";
export const KEY_ONBOARDING = "maria_onboarding_done";
export const KEY_CONVERSACION = "maria_conversacion";
export const MARIA_STORAGE_KEYS = [KEY_DIA, KEY_ONBOARDING, KEY_CONVERSACION];
